import * as React from 'react';
import { Translate } from 'react-redux-i18n';
import { Dispatch } from 'react-redux';

import { StoreState } from '../../../../reducers';
import { ImportFileState } from '../../../../containers/ImportManager/reducer';
import { cancelFilesImport, restartFilesImport } from '../../../../containers/ImportManager/actions';
import RemainingTimeLabel from '../RemainingTimeLabel';
import {
	StyledSubHeader,
	ButtonCancelAll,
	ButtonRestart,
} from '../styles';
import Utils from '../../../../utils';

interface SubHeaderProps {
	isDisplayed: boolean;
	isRestartAllEnabled: boolean;
	files: ImportFileState[];
	remainingImportTime: number;
	dispatch: Dispatch<StoreState>;
}

const SubHeader = ({
	isDisplayed,
	isRestartAllEnabled,
	files,
	remainingImportTime,
	dispatch,
}: SubHeaderProps) => {
	const handleCancelAll = () => {
		const ids = files
			.filter(({ isImportFinished, error }) => !isImportFinished && !error)
			.map(({ id }) => id as string);
		dispatch(cancelFilesImport(ids));
	};

	const handleRestartAll = () => {
		const ids = files
			.filter(({ isImportCanceled }) => isImportCanceled)
			.map(({ id }) => id as string);
		dispatch(restartFilesImport(ids));
	};

	if (!isDisplayed) {
		return null;
	}

	return (
		<StyledSubHeader>
			{isRestartAllEnabled
				? (
					<ButtonRestart
						type="button"
						onClick={handleRestartAll}
					>
						<Translate value="messages.restart_all" />
						{Utils.getSvgIcon('iconset_uprez_refresh')}
					</ButtonRestart>
				)
				: (
					<>
						<RemainingTimeLabel seconds={remainingImportTime} />
						<ButtonCancelAll
							type="button"
							onClick={handleCancelAll}
						>
							<Translate value="messages.cancel" />
						</ButtonCancelAll>
					</>
				)
			}
		</StyledSubHeader>
	);
};

export default SubHeader;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ImportDesktopFile/Toast/SubHeader/index.tsx